import { useQuery } from '@tanstack/react-query';
import type { FinanceOverview, OnboardingStatus } from '@vuokramani/shared';
import { api } from './api.ts';

/** Kaikkien asuntojen talous vuodelta. */
export function useFinance(year: number) {
  return useQuery({
    queryKey: ['finance', year],
    queryFn: () => api<FinanceOverview>(`/finance?year=${year}`),
    // Laskut ja kulut muuttuvat asuntojen välilehdillä: haetaan aina sivulle tultaessa.
    staleTime: 0,
  });
}

/** Aloitusohjeen laskupohja- ja kuluaskeleet (kaikki vuodet). */
export function useOnboardingStatus(enabled: boolean) {
  return useQuery({
    queryKey: ['onboarding'],
    queryFn: () => api<OnboardingStatus>('/finance/onboarding'),
    staleTime: 0,
    enabled,
  });
}
